import { FC, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { InfoDetailVO } from '@domain/vo/info/infoDetailVO';
import classnames from 'classnames/bind';
import styles from './liveChat.module.scss';

const cx = classnames.bind(styles);

const maskingName = (name: string | undefined | null) => {
  if (!name) return '';
  const arr = name.split('');
  const len = arr.length;

  if (len === 2) {
    arr.splice(1, 1, '*');
    return arr.join('');
  }

  arr.forEach((c, i) => {
    if (i === 0 || i === len - 1) return;
    arr.splice(i, 1, '*');
  });

  return arr.join('');
};

interface LiveChatProps {
  detailData?: InfoDetailVO;
}

const LiveChat: FC<LiveChatProps> = ({ detailData }) => {
  const { query } = useRouter();
  const postSn = Number(query.sn);
  const { data: userInfo } = useUserInfo();

  const chatSrc = `${detailData?.chatUrl}?key=${userInfo?.id}&name=${maskingName(
    userInfo?.name,
  )}&roomSn=${postSn}&managerImgUrl=${detailData?.logoUid}`;
  const validateChat = detailData;

  useEffect(() => {
    if (!query.sn) return;
  }, [query.sn]);

  return (
    <div className={cx('liveChat')}>
      {validateChat ? (
        <iframe data-type="chat" src={chatSrc} width="100%" height="100%" frameBorder="0" scrolling="no" />
      ) : (
        <>준비중입니다.</>
      )}
    </div>
  );
};

export default LiveChat;
